import { useEffect, useState } from "react";
import { io } from "socket.io-client";

function useSocket(token: any) {
 const [socket, setSocket] = useState<any>(null);

 useEffect(() => {
  if (!!token && socket == null) {
   // base URL code added
   const baseURL = process.env.REACT_APP_SERVER_URL ?? "";
   const socketData = io(baseURL, {
    auth: {
     token,
    },
    transports: ["websocket"],
   });
   socketData.emit("join", {});
   setSocket(socketData);
  }
 }, [token]);

 return socket;
}

export default useSocket;
